import "@hallyulytics/ui/styles.css";
import { hydrateApplication } from "@hallyulytics/router";
import { routes } from "./router";
await hydrateApplication(routes);
